<template>
  <div class="d-flex align-center justify-center">
    <v-btn icon small @click="dialog = true">
      <v-icon>mdi-pencil-outline</v-icon>
    </v-btn>

    <span class="ml-2">{{ datetime(data.followup_date, 'date') }}</span>

    <custom-popup v-model="dialog" :cons="{title: 'تغییر وضعیت'}" hide-confirm max-width="450">
      <v-card flat>
        <v-card-title>
          <div class="flex">
            <date-picker
              v-model="data.followup_date" auto-submit display-format="jYYYY-jMM-jDD" format="YYYY-MM-DD"
              label="انتخاب تاریخ" type="date"/>
          </div>
          <v-btn class="mr-2" icon @click="data.followup_date = null">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions class="justify-end px-4" @click="sendText">
          <v-btn :loading="loading" class="btn-accept rounded-lg ma-0" depressed>ذخیره</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "editReportDate",

  props: {
    data: Object
  },

  data: () => ({
    dialog: false,
    loading: false
  }),

  methods: {
    sendText() {
      this.loading = true;

      this.requestApiPost(`task/smsReports/followups/${this.data.id}`, {
        date: this.data.followup_date
      })
        .then(({data}) => {
          this.$toast.success('با موفقیت ذخیره شد.');
          this.dialog = false
        })
        .catch(({response}) => console.log('failed to save text: ', response))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>